export default __webpack_public_path__ + "static/funcionamiento-icono-1-3f2df3551aa0f424273059a2332da090.png";